import { EntityId, PaginationRequest } from '../common';

export interface AddressesRequest extends PaginationRequest {
  addressesIds?: EntityId[];
}
